<div class="grid container align-center">
	<div [class]="this.pdfCss">
		<div class="card-task-detail relative">
			<div *ngIf="!hasError">

				<app-task-report-panel
					[currentTask]="currentTask"
					[isLoading]="isLoading"
					[isPrimary]="true"
					[isSubmitDisabled]="isSubmitting"
					[viewerPanelInFocus]="pdfPanelInFocus"
					[topSpacerClass]="showPanelPadding"
					[viewerAvailability]="reportViewerAvailability"
					[activeViewer]="activeReportViewer"
					(activeViewerChanged)="activeReportViewer = $event"
					[fallbackBackUrl]="'/dashboard'"
					[isPhobosTask]="true"
					[phobosTaskInstance]="phobosTaskInstance"
					[formActionsContainerClass]="flexCss"
					(nextRequested)="goToNextTask()"
					(previousRequested)="goToPreviousTask()"
					(reviewRequested)="onReview()"
					(groupChanged)="groupSelected($event)"
					(assignRequested)="assign($event)"
					(completeRequested)="complete($event)"
					(reopenRequested)="reOpen($event)"
					(resendRequested)="resend($event)"
				>
					<app-pdf-file-panel
						*ngIf="activeReportViewer === 'pdf'"
						(uploadFile)="uploadWorkflowFile($event)"
						[containerId]="mainPdfContainer"
						[currentFile]="primaryFile"
						[currentTask]="currentTask"
						[hasPdfReport]="primaryFile.storageId !== undefined"
						[isLoading]="isLoading"
						[isPrimary]="true"
						[phobosTaskInstance]="phobosTaskInstance"
					></app-pdf-file-panel>

					<app-html-report-viewer
						*ngIf="activeReportViewer === 'html'
      && !isHtmlReportLoading
      && isHtmlReportEnabled
      && phobosTaskInstance?.id
      && reportType"
						[taskInstanceId]="phobosTaskInstance.id"
						[useApiAnnotations]="useApiHtmlAnnotations"
						[reportType]="reportType ?? ''"
						[reportData]="htmlReportData"
						[seedAnnotations]="htmlSeedAnnotations"
						[businessDate]="phobosTaskInstance.createdDate"
						[pmsDataStatus]="primaryPmsDataStatus"
					></app-html-report-viewer>

				</app-task-report-panel>
			</div>
		</div>
	</div>

	<app-error-panel *ngIf="hasError"></app-error-panel>

	<div class="flex justify-content-center mx-3 pt-5">
		<div class="hidden xl:block">
			<app-round-button-left
				(LeftClick)="getOpenComment()"
				[hidden]="!this.pdfPanelInFocus"
			></app-round-button-left>

			<app-round-button-right
				(RightClick)="getOpenPdf()"
				[hidden]="this.pdfPanelInFocus"
			></app-round-button-right>
		</div>
	</div>

	<div *ngIf="!hasError" [class]="this.commentsCss">
		<div class="card relative">
			<app-document-side-panel
				(addComment)="openCommentDialog()"
				[aiData]="aiData"
				[currentTask]="this.currentTask"
				[hasPrimaryDocument]="this.primaryFile.documentId !== undefined"
				[isPhobos]="true"
				(taskInstanceRefreshRequested)="refreshTaskInstance()"
			></app-document-side-panel>
		</div>
	</div>

	<app-complete-form-dialog
		(dialogClose)="this.completeFormDialogClose()"
		[formId]="this.phobosTaskInstance.id"
		[isResend]="this.isResend"
		[isVisible]="this.isCompleteFormVisible"
	></app-complete-form-dialog>

	<app-add-coment-dialog
		(commentDialogClose)="this.onDialogClose()"
		[currentFile]="this.primaryFile"
		[isVisible]="this.isCommentDialogVisible"
		[processId]="this.phobosTaskInstance.id"
		[taskType]="WorkflowType.Form"
	></app-add-coment-dialog>
</div>
